import { type UserLoop } from 'types/userLoop';
import { DEFAULT_ENTROPY } from 'pages/Remixer/constants';
import { type BaseSongResponse } from '../../responses/responseTypes';
import { SongType } from './enums';
import { BaseSong } from './baseSong';

/**
 * @deprecated: classes should not be used in redux
 */
export class AIGeneratedSong extends BaseSong {
  userLoop: UserLoop | null;

  constructor(data: BaseSongResponse) {
    super(SongType.AI_GENERATED, data);

    const extraParams = data.formula?.extra_params;
    const { entropy, user_audio: userAudio } = extraParams || {};

    if (userAudio) {
      const { id: loopId, filename: loopFileName } = userAudio;
      this.userLoop = {
        loopId,
        loopFileName,
        entropy: entropy ?? DEFAULT_ENTROPY,
        instrument: '',
      };
    } else {
      this.userLoop = null;
    }
  }
}
